import { z } from 'zod'
import { FilePoolUploadConfirmationResponseDtoSchema } from './file'

export const RlcpContentDtoSchema = z.object({
  id: z.string(),
  name__v: z.string(),
  get children() {
    return z.array(RlcpContentDtoSchema)
  },
  document_id: z.number().optional(),
  major_version: z.number().optional(),
  minor_version: z.number().optional(),
  version_id: z.string().optional(),
  created_date: z.string().optional(),
  modified_date: z.string().optional(),
  document_url: z.string().optional(),
})

export const RlcpStructureItemDtoSchema = z.object({
  content_plan__v: z.string(),
  id: z.string(),
  name__v: z.string(),
  content_plan: RlcpContentDtoSchema,
})

export const RlcpFilesResponseDtoSchema = z.array(RlcpStructureItemDtoSchema)

export const RlcpUploadSuccessResponseDtoSchema = z.object({
  success: z.boolean(),
  total: z.number(),
  queued: z.number(),
  results: z.array(FilePoolUploadConfirmationResponseDtoSchema),
})

export const RlcpUploadFailureResponseDtoSchema = z.object({
  detail: z.object({
    message: z.string(),
    queued: z.number(),
    failed: z.number(),
    failures: z.array(
      z.object({
        version_id: z.string(),
        filename: z.string(),
        detail: z.string(),
      })
    ),
  }),
})

export type RlcpContentDto = z.infer<typeof RlcpContentDtoSchema>
export type RlcpStructureItemDto = z.infer<typeof RlcpStructureItemDtoSchema>
export type RlcpFilesResponseDto = z.infer<typeof RlcpFilesResponseDtoSchema>
export type RlcpUploadSuccessResponseDto = z.infer<typeof RlcpUploadSuccessResponseDtoSchema>
export type RlcpUploadFailureResponseDto = z.infer<typeof RlcpUploadFailureResponseDtoSchema>
